import type { AnnotationCategory, AnnotationItem } from "@factory-twin/contracts";

interface Props {
  annotation: AnnotationItem;
  onChange: (annotation: AnnotationItem) => void;
  onDelete: () => void;
  onClose: () => void;
}

const categories: Array<{ value: AnnotationCategory; label: string }> = [
  { value: "safety", label: "⚠ 安全注意" },
  { value: "procedure", label: "↳ 作業手順" },
  { value: "equipment", label: "◇ 設備説明" },
  { value: "note", label: "· メモ" },
];

export function AnnotationEditor({ annotation, onChange, onDelete, onClose }: Props) {
  return <aside className="annotation-editor">
    <header><div><span>ANNOTATION</span><strong>{annotation.id.slice(0, 8).toUpperCase()}</strong></div><button onClick={onClose} aria-label="閉じる">×</button></header>
    <div className="editor-pin"><i className={annotation.category} /><span>X {annotation.position.x.toFixed(3)}<br />Y {annotation.position.y.toFixed(3)}<br />Z {annotation.position.z.toFixed(3)}</span></div>
    <label>カテゴリ<select value={annotation.category} onChange={(event) => onChange({ ...annotation, category: event.target.value as AnnotationCategory })}>{categories.map((category) => <option value={category.value} key={category.value}>{category.label}</option>)}</select></label>
    <label>タイトル<input value={annotation.title} maxLength={200} onChange={(event) => onChange({ ...annotation, title: event.target.value })} /></label>
    <label>説明<textarea value={annotation.content} maxLength={10_000} placeholder="危険内容、確認事項、作業手順を入力…" onChange={(event) => onChange({ ...annotation, content: event.target.value })} /></label>
    <button className="delete-button" onClick={onDelete}>この注釈を削除</button>
  </aside>;
}

